import { useState } from "react";
import { icons } from "../../constants";

const HexagonRequirement = ({
  backgroundImage,
  circlePosition = "left", // top-left, top, top-right, right, bottom-right, bottom, bottom-left, left
  arrowPosition = "left", // top-left, top, top-right, right, bottom-right, bottom, bottom-left, left
  circleIcon,
  arrow,
  title,
  description,
  detailItems = [], // now an array of s,trings
  type = "blue", // 'blue' or 'yellow',
  margin = "0",
  internalMessageMargin = "0",
  internalMessageMarginDetail = "0"
}) => {
  const [showDetail, setShowDetail] = useState(false);

  const getCircleStyle = (position) => {
    switch (position) {
      case "top-left":
        return { top: "10px", left: "30px" };
      case "top":
        return { top: "-10px", left: "50%", transform: "translateX(-50%)" };
      case "top-right":
        return { top: "10px", right: "30px" };
      case "right":
        return { top: "50%", right: "-45px", transform: "translateY(-50%)" };
      case "bottom-right":
        return { bottom: "10px", right: "30px" };
      case "bottom":
        return { bottom: "-10px", left: "50%", transform: "translateX(-50%)" };
      case "bottom-left":
        return { bottom: "10px", left: "30px" };
      case "left":
        return { top: "50%", left: "-45px", transform: "translateY(-50%)" };
      default:
        return { top: "50%", left: "-20px", transform: "translateY(-50%)" };
    }
  };

    const getArrowStyle = (position) => {
    switch (position) {
      case "top-left":
        return { top: "-20px", left: "77px" };
      case "top":
        return { top: "-10px", left: "50%", transform: "translateX(-50%)" };
      case "top-right":
        return { top: "17px", right: "-11px" };
      case "right":
        return { bottom: "90px", right: "-50px", transform: "translateY(-50%)" };
      case "bottom-right":
        return { bottom: "-20px", right: "70px" };
      case "bottom":
        return { bottom: "-10px", left: "50%", transform: "translateX(-50%)" };
      case "bottom-left":
        return { bottom: "20px", left: "2px" };
      case "left":
        return { top: "110px", left: "-40px", transform: "translateY(-50%)" };
      default:
        return { top: "50%", left: "-20px", transform: "translateY(-50%)" };
    }
  };

  const color = type === "blue" ? "#2a23d1" : "#fdcd04";
  const textColor = type === "blue" ? "white" : "black";

  const iconWhite = !showDetail ? icons.info_white : icons.back_white;
  const iconBlack = !showDetail ? icons.info_back : icons.back_black;

  const icon = type === "blue" ? iconWhite : iconBlack;

  return (
    <div
      style={{ position: "relative", width: 270, height: 320, margin: margin }}
    >
      <img
        src={backgroundImage}
        alt="Hexágono"
        style={{ height: "100%", width: "280px", objectFit: "contain" }}
      />
      <div
        style={{
          position: "absolute",
          ...getCircleStyle(circlePosition),
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `8px solid ${color}`
        }}
      >
        {typeof circleIcon === "string" ? (
          <img src={circleIcon} alt="icon" style={{ width: 40 }} />
        ) : (
          circleIcon
        )}
      </div>

      <div
        style={{
          position: "absolute",
          ...getArrowStyle(arrowPosition),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: '10000'
        }}
      >
        {typeof circleIcon === "string" ? (
          <img src={arrow} alt="icon" />
        ) : (
          arrow
        )}
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 95,
          left: 15,
          right: 15,
          textAlign: "left",
          color: textColor,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0 20px",
          width: '260px'
        }}
      >
        <div
          className="VContainer align-center"
          style={{
            margin: showDetail
              ? internalMessageMarginDetail
              : internalMessageMargin
          }}
        >
          <img
            className="hex-icon pointer"
            src={icon}
            alt="icon"
            style={{ marginRight: "10px" }}
            onClick={() => setShowDetail((prev) => !prev)}
          />

          {showDetail ? (
            <>
              <h4 style={{ margin: "10px 0", textAlign: "center" }}>
                Información asociada:
              </h4>
              <ul
                className="hex-list"
                style={{
                  fontSize: 13,
                  paddingLeft: 20,
                  margin: 0,
                  listStyleType: "circle"
                }}
              >
                {detailItems.map((item, index) => (
                  <li
                    style={{
                      fontSize: 11,
                      margin: 0,
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      overflowWrap: "break-word"
                    }}
                    key={index}
                  >
                    ● {item}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <>
              <h4 style={{ margin: "10px 0", textAlign: "center" }}>{title}</h4>
              <p
                style={{
                  fontSize: 12.5,
                  margin: 0,
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  overflowWrap: "break-word"
                }}
              >
                {description}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HexagonRequirement;
